import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import Body from 'components/typography/body1/index'
import Chip from 'react-toolbox/lib/chip'

import styles from './styles.scss'

const ChipComponent = ({ content, deletable, onDeleteClick }) => {
  return (
    <Chip
      deletable={deletable}
      onDeleteClick={onDeleteClick}
      theme={styles}
    >
      <Body>
        { content }
      </Body>
    </Chip>
  )
}

ChipComponent.propTypes = {
  content: PropTypes.string.isRequired,
  deletable: PropTypes.bool.isRequired,
  onDeleteClick: PropTypes.func,
}

ChipComponent.defaultProps = {
  content: '',
  deletable: false,
}

const withStyle = CSSModules(styles)
export default withStyle(ChipComponent)
